var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"spinner-icon",attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":_vm.strokeWidth,"stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }